import { render, staticRenderFns } from "./googleAds.vue?vue&type=template&id=373c1cbc&scoped=true&"
import script from "./googleAds.vue?vue&type=script&lang=js&"
export * from "./googleAds.vue?vue&type=script&lang=js&"
import style0 from "./googleAds.vue?vue&type=style&index=0&id=373c1cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373c1cbc",
  null
  
)

export default component.exports